







































































import { AvisDeVirement } from "../../models/AvisDeVirement";
import AvisDeVirementLignes from "../AvisDeVirementListPartials/AvisDeVirementLignes.vue";

export default {
    name: "AvisDeVirementModalDisplay",
    components: { AvisDeVirementLignes },
    props: {
        avisDeVirement: AvisDeVirement
    },
    methods: {
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
    },
};
